import { download } from '../../../../../app/actions/spaces/download/DownloadAction';
import { Messages } from '../../../../../codegen/Localize';
import { IDownloadAction } from '../../../../../ts/ServerApi/types/actionNames';
import { IContentInfo } from '../../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from '../IEntityAction';
import { isSingleEmbeddedDatasource } from '../IEntityActionHelpers';

export const DownloadEntityAction: IEntityAction<IContentInfo<'workbook' | 'datasource' | 'flow'>, IDownloadAction> = {
  name: EntityActionNames.Download,
  translateName: Messages.download_action,
  isVisible: (targetItems: IContentInfo<'datasource' | 'workbook' | 'flow'>[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IDownloadAction, targetItems: IContentInfo[]) =>
      targetItems.length === 1 && availableActions && availableActions.download,
  createReduxAction: (items: IContentInfo[]) => download(items[0])
};
